<template>
  <div id="debugMenu">



    <button v-on:click="store.sendOrderToStrapi()" class="btn btn-secondary btn-sm">Send store Order</button>

  </div>
</template>

<script>

import {store} from "./store.js";

export default {
  name: "DebugMenu",
  data() {
    return {
      store
    }
  },
  methods: {

  },
  computed: {},
  mounted() {
    console.log('DebugMenu Start')
  }
}
</script>

<style scoped>
#debugMenu {
  position: absolute;
  top: 0;
  left: 0;
  padding: .51rem;
  z-index: +1000;
  background-color: #dfc8ba;
}
</style>